import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { MessageDetails } from "../containers/messaging/details";

// Lets any screen open the message sheet (the Messaging page, the Dashboard
// panel). One sheet, mounted once in AppLayout.
//
//   const { openComposer, openMessage, savedAt } = useMessageComposer();
//   openComposer({ type: "bolo", site_ids: [12] })   // compose, optionally prefilled
//   openMessage(id, { tab: "Recipients" })
//
// `savedAt` changes after every send/edit/end so lists know to refetch.
const MessageComposerContext = createContext(null);

function MessageComposerProvider({ children }) {
  const [state, setState] = useState({ isOpen: false, messageId: null, prefill: null });
  const [savedAt, setSavedAt] = useState(0);

  const openComposer = useCallback(
    (prefill = null) => setState({ isOpen: true, messageId: null, prefill }),
    []
  );
  const openMessage = useCallback(
    (messageId, options = null) => setState({ isOpen: true, messageId, prefill: options }),
    []
  );
  const close = useCallback(() => setState((prev) => ({ ...prev, isOpen: false })), []);
  const onSaved = useCallback(() => setSavedAt(Date.now()), []);

  const value = useMemo(
    () => ({ openComposer, openMessage, savedAt }),
    [openComposer, openMessage, savedAt]
  );

  return (
    <MessageComposerContext.Provider value={value}>
      {children}
      <MessageDetails
        isOpen={state.isOpen}
        onClose={close}
        messageId={state.messageId}
        prefill={state.prefill}
        onSaved={onSaved}
      />
    </MessageComposerContext.Provider>
  );
}

const useMessageComposer = () => useContext(MessageComposerContext);

export { MessageComposerProvider, useMessageComposer };
